module.exports = __webpack_public_path__ + "static/polityka_prywatnosci_i_cookies_pl-da2f1628bb1650a4f698d544b5cdb8d3.pdf";